<template>
  <div>
    <div class="modal_wrap" :class="{ on: isShow }">
      <!--'on 추가'-->
      <div class="modal_inner">
        <div class="modal">
          <div class="modal_head">
            <!--<h1 class="h1"></h1>-->
          </div>
          <div class="modal_con">
            <div class="modal_txt">
              <div class="center">
                <span class="color bold"
                  >퍼스에서 보내는 알림(Push)를<br />
                  받아보시겠습니까?</span
                ><br />
                <br />
                수신 동의 시 퍼스에서 제공하는<br />
                다양한 알림을 받아볼 수 있습니다.<br />
                <br />
                알림 설정 후<br />
                [마이페이지 > 알림 설정] 에서<br />
                변경할 수 있습니다.
              </div>
            </div>
          </div>
          <div class="modal_btn">
            <div class="btn_wrap">
              <button class="btn bo grey" @click="openAppPushDisagreeModal">
                비동의
              </button>
              <button class="btn" @click="openAppPushAgreeModal">동의</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AppPushAgreeModal
      :show="isShowAppPushAgreeModal"
      @close="hideAppPushModal"
    />
    <AppPushDisagreeModal
      :show="isShowAppPushDisagreeModal"
      @close="hideAppPushModal"
    />
  </div>
</template>
<script>
import AppPushAgreeModal from '@/front/customer/views/home/modal/AppPushAgreeModal';
import AppPushDisagreeModal from '@/front/customer/views/home/modal/AppPushDisagreeModal';
import { mapActions as userMapActions } from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

export default {
  components: {
    AppPushAgreeModal,
    AppPushDisagreeModal,
  },
  props: {
    show: Boolean,
  },
  data() {
    return {
      isShow: false,
      isShowAppPushAgreeModal: false,
      isShowAppPushDisagreeModal: false,
    };
  },
  watch: {
    show() {
      this.isShow = this.show;
    },
  },
  methods: {
    ...userMapActions([userTypes.USER_UPDATE_ME]),
    hideAppPushModal() {
      this.isShowAppPushAgreeModal = false;
      this.isShowAppPushDisagreeModal = false;
    },

    // 동의
    openAppPushAgreeModal() {
      this.isShow = false;
      this.isShowAppPushAgreeModal = true;
      this.notificationAllChange(true);
    },

    // 비동의
    openAppPushDisagreeModal() {
      this.isShow = false;
      this.isShowAppPushDisagreeModal = true;
      this.notificationAllChange(false);
    },

    notificationAllChange(active) {
      const params = [
        { name: 'notificationKnowhow', value: active },
        { name: 'notificationKnowhowReply', value: active },
        { name: 'notificationFree', value: active },
        { name: 'notificationFreeReply', value: active },
        { name: 'notificationChat', value: active },
        { name: 'notificationQna', value: active },
        // {
        //   name: 'notificationKeyword',
        //   value: active,
        // },
      ];
      const payload = new FormData();
      for (const i in params) {
        payload.append(params[i].name.toString(), params[i].value);
      }

      this[userTypes.USER_UPDATE_ME](payload);
    },
  },
};
</script>
